import { i18n, sprintf, getBDCountry, isCountryChile } from '@/common/utils/i18n'
import i18nVue from '@/i18n/locale'
import { get } from 'lodash-es'
import ruleConfig from '@/common/utils/rules-COM'
import ShopType from '@/pages-COM/shopDetail/config/ShopType'
import { getFormatCommonConfig } from '@/common/utils/commonApi'
import { BUSINESS_MODEL_LIST } from '@/consts'

import {
  SIGN_LEGAL_TYPE_LIST,
  SIGN_LEGAL_TYPE_LIST_MX,
  SIGN_LEGAL_TYPE_LIST_CO,
  SIGN_LEGAL_TYPE_LIST_CL,
  SIGN_LEGAL_TYPE_LIST_DO,
  SIGN_LEGAL_TYPE_LIST_PE,
  SIGN_CONTRACT_TYPE_LIST,
  SIGN_DELIVERY_TYPE_LIST,
  SIGN_PARTYA_TITLE_LIST,
  SIGN_CONTRACTOR_TYPE_LIST,
  SIGN_CONTRACTOR_TYPE_LIST_BR,
  SIGN_CONTRACTOR_TYPE_LIST_CL,
  SIGN_CONTRACTOR_TYPE_LIST_PE,
  STARTUP_MONEY_SELECT_LIST_CONFIG_MX,
  STARTUP_MONEY_SELECT_LIST_CONFIG_BR,
  STARTUP_MONEY_SELECT_LIST_CONFIG_CO,
  STARTUP_MONEY_SELECT_LIST_CONFIG_CL,
  STARTUP_MONEY_SELECT_LIST_CONFIG_PE,
  TAX_TYPE,
  CO_ACCOUNT_TYPE,
  PHONE_PERFIX,
  CL_ACCOUNT_TYPE,
  PE_ACCOUNT_TYPE,
  EQUIPMENT_INFO_PAD_SELECT_LIST,
  ID_TYPE_PERSONAL,
  ID_TYPE_COMPANY,
  TAX_VAT_PAYMENT_LIST,
  LOCALE_TAX_VAT_PAYMENT_LIST,
  KP_CONTACTMODE,
  getCountryFullNameConfig,
  SIGN_PARTY_TYPE_LIST_V2,
} from '@/config/sign/enums'
const country = getBDCountry() || 'MX'
const nI18n = {
  gettext: i18n.gettext,
  sprintf,
}
const beneficiaryIdTypes = (() => {
  const Lib = {
    COM: [
      [i18nVue.t('FoodB_Show_ID_Card_BrxO' /** 身份证 */), 9],
      [i18nVue.t('FoodB_Show_Aliens_Residence_creU' /** 外国人居留卡 */), 10],
      [i18nVue.t('FoodD_payout_Company_Registration_zoVW' /** 公司注册号 */), 11],
    ],
    CO: [
      [i18nVue.t('FoodB_Show_ID_Card_BrxO' /** 身份证 */), 9],
      [i18nVue.t('FoodB_Show_Aliens_Residence_creU' /** 外国人居留卡 */), 10],
      [i18nVue.t('Others_platform_Tax_documents_jEir' /** 税务证件号 */), 15],
      // [this.$t('FoodD_payout_Company_Registration_zoVW' /** 公司注册号 */), 11]
    ],
    DO: [
      [i18nVue.t('FoodB_Launch_DR_ID_AnVk' /** DR-身份证 */), 16],
      [i18nVue.t('FoodB_Launch_DR_Military_Rxvi' /** DR-军人证 */), 17],
      [i18nVue.t('FoodB_Launch_DR_Foreigner_gXpW' /** DR-外国人证 */), 18],
      [i18nVue.t('FoodB_Launch_DR_Temporary_BQFH' /** DR-临时居留证 */), 19],
      [i18nVue.t('FoodB_Launch_DR_Passport_JChW' /** DR-护照 */), 20],
    ],
    PE: [
      [i18nVue.t('FoodOpB_Translation_ID_Card_jQZG' /** 身份证 */), 27],
      [i18nVue.t('FoodOpB_Translation_Tax_ID_yEbh' /** RUC（tax id） */), 28],
      [i18nVue.t('FoodOpB_Translation_Foreigner_hMcE' /** 外国人卡 */), 29],
      [i18nVue.t('FoodOpB_Translation_Passport_jpaq' /** 护照 */), 30],
    ],
  }
  return (Lib[country] || Lib.COM).map(([text, value]) => ({ text, value }))
})()
export const ACCOUNT_TYPE_LIST = [
  {
    value: 1,
    text: i18n.gettext('对公'),
  },
  {
    value: 2,
    text: i18n.gettext('对私'),
  },
]
export class Rule {
  constructor(callback) {
    this.callback = callback
  }

  getRule() {
    return this.callback
  }
}
export default function (checkFields = false) {
  const multiPhonesRule = ruleConfig.multiplePhones('', nI18n, [3])
  const phoneRule = ruleConfig.phone('', nI18n)
  const decimalRule = ruleConfig.decimal('', nI18n, [2])
  const { signType } = this
  const _this = this
  console.log('signType = ', signType)
  const postCodeRule = ruleConfig.postCode('', nI18n)
  const emailRule = ruleConfig.email('', nI18n)
  const required = ruleConfig.required('', nI18n)
  const { currentAllConfig } = this
  // 考虑新加一个字段来获取页面实际上需要校验的必填值
  const legalType = get(this.signForm, 'legalInfo.legalType', '')
  const signTypeForCheckField = this.signType || get(this.signForm, 'signType', '')
  const beneficiaryIdType = get(this.signForm, 'contractInfo.beneficiaryIdType', '')

  return {
    source: {
      label: 'source',
      type: 'static',
      prop: 'source',
      value: 'shop',
    },
    name: {
      label: this.gettext('门店名称'),
      prop: 'name',
      type: 'input',
      props: {
        placeholder: this.gettext('请输入'),
      },
      rules: {
        required: true,
        max: 90,
      },
    },
    businessType: {
      label: this.$t('Gattaran_Mode_DJzU_JeyE' /** 业态 */),
      prop: 'businessType',
      type: 'select',
      props: {
        options: BUSINESS_MODEL_LIST,
        placeholder: this.gettext('请选择'),
      },
      rules: {
        required: true,
      },
    },
    addr: {
      label: this.gettext('门店地址'),
      prop: 'addr',
      props: {},
      type: 'autoComplete',
      rules: {
        required: true,
      },
    },
    lnglat: {
      label: this.gettext('门店POI'),
      prop: 'lnglat',
      type: 'poi',
      props: {
        addrKey: 'addr',
      },
      rules: {
        required: true,
      },
    },
    accountType: {
      label: i18n.gettext('类型'),
      type: 'select',
      prop: 'accountType',
      props: {
        options: ACCOUNT_TYPE_LIST,
        placeholder: i18n.gettext('请选择'),
      },
      rules: ['required'],
      hide: new Rule(() => {
        return ['CO', 'DO', 'CL', 'PE', 'BR'].indexOf(country) === -1
      }),
      detailView: {
        format(data, prop) {
          const val = data[prop]
          const fd = ACCOUNT_TYPE_LIST.find(d => {
            return d.value === val
          })
          return fd && fd.text
        },
      },
    },
    /**
     * beneficiaryId: {

    },
    */

    selectCityId: {
      label: this.gettext('城市'),
      type: 'select',
      prop: 'selectCityId',
      props: {
        options: get(this, 'cityList'),
        disabled: !this.isAdd,
        placeholder: this.gettext('请选择'),
      },
      rules: {
        required: true,
      },
    },
    shopId: {
      label: this.gettext('门店ID'),
      prop: 'shopId',
      copy: true,
    },
    brand: {
      label: this.gettext('品牌名称'),
      prop: 'brand',
    },
    type: {
      label: this.gettext('门店类型'),
      prop: 'type',
      detailView: {
        format(data, prop) {
          console.log(data, prop)
          return ShopType.val2text(data[prop])
        },
      },
    },
    bdName: {
      label: this.gettext('销售姓名'),
      prop: 'bdName',
    },
    bdPhone: {
      label: this.gettext('销售电话'),
      preText: PHONE_PERFIX[country],
      prop: 'bdPhone',
    },
    clusterName: {
      label: this.gettext('商圈'),
      prop: 'clusterName',
    },
    category: {
      label: this.gettext('经营品类'),
      prop: 'category',
      detailView: {
        format: (data, prop) => {
          const category = data[prop]
          if (!category || category.length === 0) {
            return [this.gettext('暂无')].join(',')
          }
          if (currentAllConfig.category) {
            return category.map(val => currentAllConfig.category[val] || '').join(',')
          } else {
            return [this.gettext('暂无')].join(',')
          }
        },
      },
    },
    bussinessHours: {
      label: this.gettext('门店营业时间'),
      prop: 'bussinessHours',
    },
    ratingValueAvg: {
      label: this.gettext('评分'),
      prop: 'ratingValueAvg',
    },
    ratingCount: {
      label: this.gettext('总评价人数'),
      prop: 'ratingCount',
    },
    phone: {
      label: this.gettext('门店电话'),
      prop: 'phone',
      // type: 'multiPhone',
      type: 'phone',
      rules: {
        required: true,
        ...multiPhonesRule.rules,
        // ...structuredPhones.rules
      },
      props: {
        preText: PHONE_PERFIX[country],
      },
      // messages: structuredPhones.messages
      messages: multiPhonesRule.messages,
    },
    postCode: {
      label: this.gettext('邮编'),
      prop: 'postCode',
      type: 'input',
      props: {
        placeholder: this.gettext('请输入'),
      },
      rules: new Rule(() => {
        const Lib = {
          COM: {},
          PE: postCodeRule.rules,
        }
        return Lib[country] || Lib.COM
      }),
      messages: required.messages,
    },
    beneficiaryId: {
      label: this.$t('FoodOpB_CRM_Card_holder_NfIL' /** 持卡人证件号码 */),
      type: 'input',
      prop: 'beneficiaryId',
      props: {
        placeholder: this.gettext('请输入'),
      },
      hide: country === 'MX' || country === 'BR',
      rules: new Rule(() => {
        const Lib = {
          COM: [
            ['required', this.$t('FoodOpB_CRM_Card_holder_NfIL' /** 持卡人证件号码 */)],
            ['maxLength', this.$t('FoodOpB_CRM_Card_holder_NfIL' /** 持卡人证件号码 */), 12],
          ],
          CO: [
            ['required', this.$t('FoodOpB_CRM_Card_holder_NfIL' /** 持卡人证件号码 */)],
            ['maxLength', this.$t('FoodOpB_CRM_Card_holder_NfIL' /** 持卡人证件号码 */), 15],
            ['minLength', this.$t('FoodOpB_CRM_Card_holder_NfIL' /** 持卡人证件号码 */), 6],
          ],
          DO: [
            ['required', this.$t('FoodOpB_CRM_Card_holder_NfIL' /** 持卡人证件号码 */)],
            ['maxLength', this.$t('FoodOpB_CRM_Card_holder_NfIL' /** 持卡人证件号码 */), 11],
          ],
          CL: [[]],
          PE: [
            ['required', this.$t('FoodOpB_CRM_Card_holder_NfIL' /** 持卡人证件号码 */)],
            [
              'PEbeneficiaryId',
              this.$t('FoodOpB_CRM_Card_holder_NfIL' /** 持卡人证件号码 */),
              checkFields ? beneficiaryIdType : this.formModel && this.formModel.beneficiaryIdType,
            ],
          ],
        }
        return Lib[country] || Lib.COM
      }),
    },
    beneficiaryIdType: {
      label: this.$t('FoodOpB_CRM_Type_of_fbmW' /** 持卡人证件类型 */),
      type: 'select',
      prop: 'beneficiaryIdType',
      props: {
        options: beneficiaryIdTypes,
        placeholder: i18n.gettext('请选择'),
      },
      hide: country === 'MX' || country === 'BR',
      rules: [['required', this.$t('FoodOpB_CRM_Type_of_fbmW' /** 持卡人证件类型 */)]],
      detailView: {
        format(data, prop) {
          const val = data[prop]
          const fd = beneficiaryIdTypes.find(d => +d.value === val)
          return fd && fd.text
        },
      },
    },
    partyaCompanyId: {
      label: this.$t('FoodOpB_CRM_Party_B_BCQp' /** 乙方企业注册号 */),
      prop: 'partyaCompanyId',
      hide: country === 'MX' || country === 'BR',
      type: 'input',
      props: {
        placeholder: this.gettext('请输入'),
      },
      rules: new Rule(() => {
        const Dic = {
          CR: [
            ['minLength', this.$t('FoodOpB_CRM_Party_B_BCQp' /** 乙方企业注册号 */), 9],
            ['maxLength', this.$t('FoodOpB_CRM_Party_B_BCQp' /** 乙方企业注册号 */), 12],
          ],
          CO: [['minLength', this.$t('FoodOpB_CRM_Party_B_BCQp' /** 乙方企业注册号 */), 9]],
          COM: [['requireLength', this.$t('FoodOpB_CRM_Party_B_BCQp' /** 乙方企业注册号 */), 10]],
          CL: [
            ['required', this.$t('FoodOpB_CRM_Party_B_BCQp' /** 乙方企业注册号 */)],
            ['requireLength', this.$t('FoodOpB_CRM_Party_B_BCQp' /** 乙方企业注册号 */), 10],
          ],
          PE: [['required', this.$t('FoodOpB_CRM_Party_B_BCQp' /** 乙方企业注册号 */)]],
        }
        return Dic[country] || Dic.COM
      }),
    },
    taxPayerIdcard: {
      label: i18nVue.t('FoodB_collection_Taxpayer_ID_zntM' /** 纳税人身份证CURP */),
      checkVisible: data => `${data.taxId}`.length !== 12,
      type: 'input',
      prop: 'taxPayerIdcard',
      hide: country !== 'MX',
      placeholder: i18n.gettext('请输入'),
      rules: [
        ['required', i18nVue.t('FoodB_collection_Taxpayer_ID_zntM' /** 纳税人身份证CURP */)],
        'curpRules',
      ],
    },
    taxPayerPostcode: {
      label: i18nVue.t('FoodB_collection_Taxpayer_Postal_guUo' /** 纳税人邮政编码全国 */),
      type: 'input',
      prop: 'taxPayerPostcode',
      hide: new Rule(() => {
        return ['CO', 'DO', 'CR', 'PE', 'CL'].indexOf(country) !== -1
      }),
      placeholder: i18n.gettext('请输入'),
      rules: ['required', 'postCodeRules'],
    },
    taxSourceType: {
      label: i18nVue.t('FoodB_collection_Tax_Classification_uJHT' /** '税制分类（全国）' **/),
      hide: country !== 'MX',
      type: 'select',
      prop: 'taxSourceType',
      props: {
        placeholder: i18n.gettext('请输入'),
        options: [],
      },
      fetch: async function () {
        const taxSourceType = await getFormatCommonConfig({
          type: 'taxSourceType',
        })
        return {
          options: taxSourceType,
        }
      },
      rules: [
        [
          'required',
          i18nVue.t('FoodB_collection_Tax_Classification_uJHT' /** '税制分类（全国）' **/),
        ],
      ],
    },
    taxPayerAddr: {
      label: this.$t('FoodOpB_CRM_Taxpayer_Address_EBwy' /** 纳税人地址（全国） */),
      type: 'input',
      prop: 'taxPayerAddr',
      props: {
        placeholder: this.gettext('请输入'),
      },
      rules: [
        ['required', this.$t('FoodOpB_CRM_Taxpayer_Address_EBwy' /** 纳税人地址（全国） */)],
        ['maxLength', this.$t('FoodOpB_CRM_Taxpayer_Address_EBwy' /** 纳税人地址（全国） */), 150],
      ],
    },
    localTaxPayer: {
      label: this.$t('FoodOpB_CRM_Taxpayer_full_tMpR' /** 纳税人全名（当地） */),
      type: 'input',
      prop: 'localTaxPayer',
      props: {
        placeholder: this.gettext('请输入'),
      },
      rules: new Rule(() => {
        const Dic = {
          COM: [
            'maxLength',
            this.$t('FoodOpB_CRM_Taxpayer_full_tMpR' /** 纳税人全名（当地） */),
            90,
          ],
          MX: [
            'required',
            ['maxLength', this.$t('FoodOpB_CRM_Taxpayer_full_fzhk'), 90],
            'specialCharsMX',
          ],
        }
        return Dic[country] || Dic.COM
      }),
    },
    taxPayer: {
      label: this.$t('FoodOpB_CRM_Taxpayer_full_fzhk' /** 纳税人全名(全国) */),
      type: 'input',
      prop: 'taxPayer',
      props: {
        placeholder: this.gettext('请输入'),
      },
      rules: new Rule(() => {
        const Dic = {
          COM: [
            ['required', this.$t('FoodOpB_CRM_Taxpayer_full_fzhk' /** 纳税人全名(全国) */)],
            ['maxLength', this.$t('FoodOpB_CRM_Taxpayer_full_fzhk' /** 纳税人全名(全国) */), 90],
          ],
          MX: [
            'required',
            ['maxLength', this.$t('FoodOpB_CRM_Taxpayer_full_fzhk'), 90],
            'specialCharsMX',
          ],
        }
        return Dic[country] || Dic.COM
      }),
    },
    accountCardType: {
      label: this.$t('FoodD_payout_Account_Type_YmVW' /** 账户类型 */),
      type: 'select',
      hide: new Rule(() => {
        return ['CR', 'CO', 'DO', 'CL', 'PE', 'BR'].indexOf(country) === -1
      }),
      prop: 'accountCardType',
      props: {
        placeholder: i18n.gettext('请选择'),
        options: new Rule(function () {
          const lib = {
            MX: CO_ACCOUNT_TYPE,
            CO: CO_ACCOUNT_TYPE,
            CL: CL_ACCOUNT_TYPE,
            PE: PE_ACCOUNT_TYPE,
          }
          return lib[country] || lib.MX
        }),
      },
      rules: ['required'],
      format(data, prop) {
        const ACCOUNT_TYPE = isCountryChile() ? CL_ACCOUNT_TYPE : CO_ACCOUNT_TYPE
        const val = data[prop]
        const fd = ACCOUNT_TYPE.find(d => {
          return +d.value === +val
        })
        return fd && fd.text
      },
    },
    bankAgentno: {
      label: i18n.gettext('银行代理number'),
      type: 'input',
      hide: country !== 'BR',
      prop: 'bankAgentno',
      props: {
        placeholder: i18n.gettext('请输入'),
      },
      rules: ['required', 'number', 'isBankIOReg'],
    },
    bankAgentDigit: {
      label: i18n.gettext('银行代理digit'),
      type: 'input',
      prop: 'bankAgentDigit',
      hide: new Rule(() => {
        return ['CO', 'DO', 'CR', 'MX', 'PE'].indexOf(country) !== -1
      }),
      props: {
        placeholder: i18n.gettext('请输入'),
      },
      rules: ['number', 'isBankIOReg'],
    },
    accountCardnoBR: {
      label: i18n.gettext('银行账户number'),
      type: 'input',
      hide: country !== 'BR',
      prop: 'accountCardno',
      props: {
        placeholder: i18n.gettext('请输入'),
      },
      rules: ['required', 'number', 'isBankIOReg'],
    },
    accountCardDigit: {
      label: i18n.gettext('银行账户digit'),
      type: 'input',
      prop: 'accountCardDigit',
      hide: new Rule(() => {
        return ['CO', 'DO', 'CR', 'MX', 'PE'].indexOf(country) !== -1
      }),
      props: {
        placeholder: i18n.gettext('请输入'),
      },
      rules: ['isBankIOReg'],
    },
    officialUrl: {
      label: this.$t('FoodOpB_CO_Store_official_VsRU' /** 商户官网 */),
      version: 'columbia open country',
      hide: new Rule(() => {
        return ['CO', 'DO', 'CL', 'PE'].indexOf(country) === -1
      }),
      type: 'input',
      prop: 'officialUrl',
      props: {
        placeholder: this.gettext('请输入'),
      },
      rules: [],
    },
    taxPaymentMethod: {
      label: this.$t('FoodB_Show_Tax_payment_xfxh' /** 纳税方式（全国） */),
      version: 'columbia open country',
      hide: new Rule(() => {
        return ['CO', 'DO', 'CL', 'PE', 'MX'].indexOf(country) === -1
      }),
      type: 'select',
      prop: 'taxPaymentMethod',
      props: {
        placeholder: i18n.gettext('请选择'),
        options: TAX_TYPE,
      },
      rules: ['required'],
      detailView: {
        format(data, prop) {
          const val = data[prop]
          const fd = TAX_TYPE.find(d => {
            return d.value === val + ''
          })
          return fd && fd.text
        },
      },
    },
    localTaxPaymentMethod: {
      label: this.$t('FoodB_Show_Tax_payment_Dbuz' /** 纳税方式（当地） */),
      version: 'columbia open country',
      hide: new Rule(() => {
        return ['CO', 'DO', 'CL', 'PE', 'MX'].indexOf(country) === -1
      }),
      type: 'select',
      prop: 'localTaxPaymentMethod',
      props: {
        placeholder: i18n.gettext('请选择'),
        options: TAX_TYPE,
      },
      rules: [],
      detailView: {
        format(data, prop) {
          const val = data[prop]
          const fd = TAX_TYPE.find(d => {
            return d.value === val + ''
          })
          return fd && fd.text
        },
      },
    },
    localTaxId: {
      label: this.$t('FoodOpB_CRM_Taxpayer_Tax_xOmZ' /** 纳税人税号 （当地） */),
      type: 'input',
      prop: 'localTaxId',
      props: {
        placeholder: this.gettext('请输入'),
      },
      rules: new Rule(() => {
        const Dic = {
          CO: [
            [
              'requireLength',
              i18nVue.t('FoodOpB_CRM_Taxpayer_Tax_xOmZ' /** 纳税人税号 （当地） */),
              10,
            ],
          ],
          COM: [
            [
              'requireLength',
              i18nVue.t('FoodOpB_CRM_Taxpayer_Tax_xOmZ' /** 纳税人税号 （当地） */),
              12,
            ],
          ],
          DO: [
            [
              'maxLength',
              i18nVue.t('FoodOpB_CRM_Taxpayer_Tax_xOmZ' /** 纳税人税号 （当地） */),
              11,
            ],
          ],
          CL: [
            [
              'requireMultyLength',
              i18nVue.t('FoodOpB_CRM_Taxpayer_Tax_xOmZ' /** 纳税人税号 （当地） */),
              8,
              9,
            ],
          ],
          PE: [
            'number',
            [
              'requireLength',
              i18nVue.t('FoodOpB_CRM_Taxpayer_Tax_xOmZ' /** 纳税人税号 （当地） */),
              11,
            ],
          ],
          MX: ['taxIdRules'],
        }
        return Dic[country] || Dic.COM
      }),
    },
    localTaxPayerAddr: {
      label: this.$t('FoodOpB_CRM_Taxpayer_Address_ptqR' /** 纳税人地址（当地） */),
      type: 'input',
      prop: 'localTaxPayerAddr',
      props: {
        placeholder: this.gettext('请输入'),
      },
      rules: [
        // ['required', i18n.gettext('纳税人地址（当地）')],
        ['maxLength', this.$t('FoodOpB_CRM_Taxpayer_Address_ptqR' /** 纳税人地址（当地） */), 150],
      ],
    },
    accountGrantPhoto: {
      label: this.gettext('结算信息照片'),
      hide: true,
      prop: 'accountGrantPhoto',
      detailView: {
        hide: false,
        type: 'image',
      },
    },
    accountBankName: {
      label: this.gettext('开户行'),
      hide: true,
      prop: 'accountBankName',
      detailView: {
        hide: false,
      },
    },
    localTaxPics: {
      label: this.$t('FoodOpB_CRM_Taxpayer_Information_Flde' /** 纳税人信息附件照片（当地） */),
      type: 'custom-upload',
      prop: 'localTaxPics',
      props: {
        max: 5,
        tip: sprintf(i18n.gettext('上传最大数量为%d张，图片上限为%dM'), 5, 5),
      },
      // rules: ['required']
      detailView: {
        type: 'image',
      },
    },
    kpName: {
      label: this.gettext('KP姓名'),
      prop: 'kpName',
      type: 'input',
      props: {
        placeholder: this.gettext('请输入'),
      },
      rules: {
        required: country === 'PE',
        max: 90,
      },
    },
    kpPhone: {
      label: this.gettext('KP电话'),
      prop: 'kpPhone',
      type: 'phone',
      props: {
        preText: PHONE_PERFIX[country],
        placeholder: this.gettext('请输入'),
      },
      rules: {
        required: country === 'PE',
        ...phoneRule.rules,
      },
      messages: phoneRule.messages,
    },
    kpOutId: {
      label: i18n.gettext('KP CPF'),
      type: 'CPFInput',
      prop: 'kpOutId',
      hide: country !== 'BR',
      placeholder: i18n.gettext('请输入'),
      rules: [['required'], 'cpfRules'],
    },
    kpPics: {
      label: this.gettext('KP CPF照片'),
      prop: 'kpPics',
      props: {
        max: 1,
        tip: sprintf(this.gettext('上传最大数量为%d张，图片上限为5MB'), 5),
        path: 'common.uploadPrivatePic',
      },
      type: 'custom-upload',
      hide: country !== 'BR',
      formatter(file) {
        const key = file.response.data.key
        return {
          key,
        }
      },
      tip: sprintf(this.gettext('上传最大数量为%d张，图片上限为5MB'), 2),
      rules: [['required']],
    },
    kpEmail: {
      label: this.gettext('KP邮箱'),
      prop: 'kpEmail',
      type: 'input',
      props: {
        placeholder: this.gettext('请输入'),
      },
      rules: {
        required: country === 'PE',
        ...emailRule.rules,
      },
      messages: emailRule.messages,
    },
    kpContactTime: {
      label: this.$t('Gattaran_0_KP_Tendency_hgOB' /** 倾向联系时间 */),
      type: 'timeRangePicker',
      prop: 'kpContactTime',
      props: {
        placeholder: this.gettext('请选择'),
      },
      detailView: {
        format(data, prop) {
          const val = data[prop]
          return val && `${val.startTime}-${val.endTime}`
        },
      },
    },
    kpContactMode: {
      label: this.$t('Gattaran_0_KP_tendency_YwDf' /** 倾向联系方式 */),
      type: 'multiSelect',
      prop: 'kpContactMode',
      props: {
        options: KP_CONTACTMODE,
        placeholder: this.gettext('请选择'),
      },
    },
    corp: {
      licensePics: {
        label: i18n.gettext('执照照片'),
        type: 'custom-upload',
        prop: 'licensePics',
        props: {
          max: 5,
          tip: sprintf(i18n.gettext('上传最大数量为%d张，图片上限为5MB'), 5),
          path: 'common.uploadPrivatePic',
        },
        formatter(file) {
          const key = file.response.data.key
          return {
            key,
          }
        },
        rules: new Rule(() => {
          const Dic = {
            COM: [],
            CO: [['required', i18n.gettext('执照照片')]],
            CL: [['required', i18n.gettext('执照照片')]],
          }
          return Dic[country] || Dic.COM
        }),
      },
    },
    proxy: {
      licensePics: {
        label: this.$t('FoodB_CL_Letter_of_EmKs' /* 委托书照片 */),
        type: 'custom-upload',
        description: [
          getBDCountry() === 'CL'
            ? this.$t('FoodB_CL_Add_any_egRn' /* 提示文案 */)
            : this.$t('FoodOpB_Translation_Please_add_mxTD' /* 提示文案 */),
          i18n.gettext('本模块支持上传文件，可至PC端操作'),
        ],
        prop: 'licensePics',
        props: {
          max: 5,
          tip: sprintf(i18n.gettext('上传最大数量为%d张，图片上限为5MB'), 5),
          path: 'common.uploadPrivatePic',
        },
        formatter(file) {
          const key = file.response.data.key
          return {
            key,
          }
        },
      },
    },
    cnpj: {
      id: {
        label: i18n.gettext('证件号'),
        type: 'CPFInput',
        prop: 'id',
        placeholder: i18n.gettext('请输入'),
        props: {
          placeholder: i18n.gettext('请输入'),
          numType: 'CNPJ',
        },
        rules: ['required', 'cnpjRules'],
      },
      licensePics: {
        label: i18n.gettext('执照照片'),
        type: 'custom-upload',
        prop: 'licensePics',
        props: {
          max: 5,
          tip: sprintf(i18n.gettext('上传最大数量为%d张，图片上限为5MB'), 5),
          path: 'common.uploadPrivatePic',
        },
        formatter(file) {
          const key = file.response.data.key
          return {
            key,
          }
        },
        rules: ['required'],
      },
    },
    city: {
      licensePics: {
        label: i18n.gettext('执照照片'),
        type: 'custom-upload',
        prop: 'licensePics',
        props: {
          max: 5,
          tip: sprintf(i18n.gettext('上传最大数量为%d张，图片上限为5MB'), 5),
          path: 'common.uploadPrivatePic',
        },
        formatter(file) {
          const key = file.response.data.key
          return {
            key,
          }
        },
        rules: new Rule(() => {
          const Dic = {
            COM: [],
            CO: [['required', i18n.gettext('执照照片')]],
            DO: [['required', i18n.gettext('执照照片')]],
            // CL: [['required', i18n.gettext('执照照片')]]
          }
          return Dic[country] || Dic.COM
        }),
      },
    },
    health: {
      licensePics: {
        label: i18n.gettext('执照照片'),
        type: 'custom-upload',
        prop: 'licensePics',
        props: {
          max: 5,
          tip: sprintf(i18n.gettext('上传最大数量为%d张，图片上限为5MB'), 5),
          path: 'common.uploadPrivatePic',
        },
        formatter(file) {
          const key = file.response.data.key
          return {
            key,
          }
        },
      },
    },
    land: {
      licensePics: {
        label: i18n.gettext('执照照片'),
        type: 'custom-upload',
        prop: 'licensePics',
        props: {
          max: 5,
          tip: sprintf(i18n.gettext('上传最大数量为%d张，图片上限为5MB'), 5),
          path: 'common.uploadPrivatePic',
        },
        formatter(file) {
          const key = file.response.data.key
          return {
            key,
          }
        },
      },
    },
    platform: {
      label: this.gettext('人工标记平台'),
      prop: 'platform',
      type: 'multiSelect',
      props: {
        options: get(this, 'platformList.hand'),
        title: this.gettext('人工标记平台'),
        placeholder: this.gettext('请选择'),
      },
    },
    sysPlatform: {
      label: this.gettext('系统标记平台'),
      prop: 'sysPlatform',
      type: 'multiSelect',
      props: {
        options: get(this, 'platformList.system'),
        title: this.gettext('系统标记平台'),
        placeholder: this.gettext('暂无'),
        disabled: true,
      },
    },
    deliveryPrice: {
      label: this.gettext('自配送费'),
      prop: 'deliveryPrice',
      type: 'input',
      props: {
        placeholder: this.gettext('请输入'),
      },
      rules: {
        type: 'number',
        ...decimalRule.rules,
      },
      messages: decimalRule.messages,
    },
    minPrice: {
      label: this.gettext('自配送起送费'),
      prop: 'minPrice',
      type: 'input',
      props: {
        placeholder: this.gettext('请输入'),
      },
      rules: {
        type: 'number',
        ...decimalRule.rules,
      },
      messages: decimalRule.messages,
    },
    deliveryDistanceTime: {
      label: this.gettext('自配送范围及时长'),
      prop: 'deliveryDistanceTime',
      type: 'input',
      props: {
        placeholder: this.gettext('请输入'),
      },
    },
    frontPhoto: {
      label: this.gettext('门脸照片'),
      prop: 'frontPhoto',
      type: 'custom-upload',
      rules: {
        // required: true
      },
    },
    frontPics: {
      label: this.$t('FoodOpB_Translation_BD_with_Jqpl' /** BD与餐厅门脸合影 */),
      hide: country !== 'PE',
      prop: 'frontPics',
      type: 'custom-upload',
      rules: {
        // required: true
      },
    },
    environmentalPhoto: {
      label: this.gettext('店内环境'),
      prop: 'environmentalPhoto',
      type: 'custom-upload',
      props: {
        max: 3,
      },
    },
    logo: {
      label: this.gettext('门店logo'),
      prop: 'logo',
      type: 'custom-upload',
      transformWebp: country !== 'BR',
      customCropper: {
        flag: country !== 'BR',
      },
      rules: {
        // 二期区分：新建普通门店非必填，编辑KA/CKA门店必填
        // required: true
      },
    },
    legalName: {
      label: i18n.gettext('法人姓名'),
      type: 'input',
      prop: 'legalName',
      tips: i18n.gettext('当该餐厅存在多个经营者时，此处必须填写合同签署人或授权合同签署人姓名'),
      props: {
        placeholder: i18n.gettext('请输入'),
      },
      rules: [
        ['required', i18n.gettext('法人姓名')],
        ['maxLength', i18n.gettext('法人姓名'), 90],
      ],
    },
    CPF: {
      label: i18n.gettext('法人CPF'),
      hide: new Rule(() => {
        return ['CO', 'DO', 'CL', 'CR', 'PE', 'MX'].indexOf(country) !== -1
      }),
      type: 'CPFInput',
      prop: 'legalId',
      props: {
        placeholder: i18n.gettext('请输入'),
      },
      rules: [['required', i18n.gettext('法人CPF')], 'cpfRules'],
    },
    legalType: {
      label: i18n.gettext('证件类型'),
      type: 'select',
      prop: 'legalType',
      exampleUrl:
        getBDCountry() === 'PE'
          ? ''
          : '//img0.didiglobal.com/static/soda_static/m/app/examplePic2.png',
      hide: country === 'BR',
      props: {
        options: new Rule(function () {
          const Lib = {
            COM: SIGN_LEGAL_TYPE_LIST,
            MX: SIGN_LEGAL_TYPE_LIST_MX,
            CO: SIGN_LEGAL_TYPE_LIST_CO,
            CL: SIGN_LEGAL_TYPE_LIST_CL,
            DO: SIGN_LEGAL_TYPE_LIST_DO,
            PE: SIGN_LEGAL_TYPE_LIST_PE,
          }
          return Lib[country] || Lib.COM
        }),
        placeholder: i18n.gettext('请选择'),
      },
      rules: [['required', i18n.gettext('证件类型')]],
    },
    legalId: {
      label: i18n.gettext('Curp号'),
      type: 'input',
      prop: 'legalId',
      props: {
        placeholder: i18n.gettext('请输入'),
      },
      hide: country === 'BR',
      rules: new Rule(() => {
        const Dic = {
          COM: [
            ['required', i18n.gettext('Curp号')],
            ['maxLength', i18n.gettext('Curp号'), 12],
          ],
          CO: [
            ['required', i18n.gettext('Curp号')],
            ['maxLength', i18n.gettext('Curp号'), 15],
            ['minLength', i18n.gettext('Curp号'), 6],
          ],
          DO: [
            ['required', i18n.gettext('Curp号')],
            ['maxLength', i18n.gettext('Curp号'), 12],
          ],
          CL: [
            ['required', i18n.gettext('Curp号')],
            ['requireLength', i18n.gettext('Curp号'), 9],
          ],
          PE: [
            ['required', i18n.gettext('Curp号')],
            [
              'PElegalId',
              i18n.gettext('Curp号'),
              checkFields ? legalType : this.formModel && this.formModel.legalType,
            ],
          ],
          MX: [['required', i18n.gettext('Curp号')], 'curpRules'],
        }
        return Dic[country] || Dic.COM
      }),
    },
    legalPics: {
      label: i18n.gettext('证件照片'),
      type: 'custom-upload',
      prop: 'legalPics',
      props: {
        max: 2,
        tip: sprintf(i18n.gettext('上传最大数量为%d张，图片上限为5MB'), 5),
        path: 'common.uploadPrivatePic',
      },
      formatter(file) {
        const key = file.response.data.key
        return {
          key,
        }
      },
      tip: sprintf(i18n.gettext('上传最大数量为%d张，图片上限为5MB'), 2),
      rules: [['required', i18n.gettext('证件照片')]],
    },
    legalExtra: {
      label: i18n.gettext('补充照片'),
      type: 'custom-upload',
      prop: 'legalExtra',
      checkVisible: data => data.legalType === 2,
      tips: i18n.gettext('若证件类型选择“老版无Curp”，需上传补充附件'),
      tip: i18n.gettext('上传最大数量为1张，图片上限为5MB'),
      props: {},
      rules: [['required', i18n.gettext('补充照片')]],
    },
    contractType: {
      label: i18n.gettext('合同类型'),
      type: 'select',
      prop: 'contractType',
      props: {
        placeholder: i18n.gettext('请选择'),
        options: SIGN_CONTRACT_TYPE_LIST,
      },
      rules: ['required'],
    },
    contractVersion: {
      label: i18n.gettext('合同版本'),
      type: 'input',
      props: {
        readonly: true,
      },
      prop: 'contractVersion',
    },
    contractNo: {
      label: i18n.gettext('合同编号'),
      type: 'input',
      prop: 'contractNo',
      span: 13,
      hide: new Rule(() => {
        return checkFields ? +signTypeForCheckField !== 1 : +_this.formModel.signType !== 1
      }),
      props: {
        placeholder: i18n.gettext('请输入'),
      },
      rules: ['required', ['maxLength', i18n.gettext('合同编号'), 90]],
    },
    partyaName: {
      label: i18n.gettext('乙方名称'),
      type: 'input',
      prop: 'partyaName',
      span: 13,
      props: {
        placeholder: i18n.gettext('请输入'),
      },
      rules: ['required', ['maxLength', i18n.gettext('乙方名称'), 90]],
    },
    partyaAddr: {
      label: i18n.gettext('乙方注册地址'),
      type: 'input',
      prop: 'partyaAddr',
      span: 13,
      placeholder: i18n.gettext('请输入'),
      rules: ['required', ['maxLength', i18n.gettext('乙方注册地址'), 150]],
    },
    partyaEmail: {
      label: i18n.gettext('乙方邮箱'),
      type: 'input',
      prop: 'partyaEmail',
      span: 13,
      placeholder: i18n.gettext('请输入'),
      rules: ['required', 'email'],
    },
    partyaContact: {
      label: i18n.gettext('乙方联系人'),
      type: 'input',
      prop: 'partyaContact',
      span: 13,
      props: {
        placeholder: i18n.gettext('请输入'),
      },
      rules: ['required', ['maxLength', i18n.gettext('乙方联系人'), 90]],
    },
    partyaIdno: {
      label: i18n.gettext('乙方联系人CPF'),
      type: 'CPFInput',
      prop: 'partyaIdno',
      hide: country !== 'BR',
      props: {
        placeholder: i18n.gettext('请输入'),
      },
      rules: ['required', 'cpfRules'],
    },
    partyaPics: {
      label: i18n.gettext('乙方联系人CPF照片'),
      type: 'custom-upload',
      prop: 'partyaPics',
      hide: country !== 'BR',
      props: {
        max: 5,
        tip: sprintf(i18n.gettext('上传最大数量为%d张，图片上限为5MB'), 5),
        path: 'common.uploadPrivatePic',
      },
      formatter(file) {
        const key = file.response.data.key
        return {
          key,
        }
      },
      rules: [['required', i18n.gettext('乙方联系人CPF照片')]],
    },
    partyaTitleType: {
      label: i18n.gettext('乙方联系人头衔'),
      type: 'select',
      prop: 'partyaTitleType',
      span: 13,
      props: {
        options: SIGN_PARTYA_TITLE_LIST,
      },
      placeholder: i18n.gettext('请选择'),
      rules: ['required'],
    },
    partyaTitleText: {
      label: i18n.gettext('请输入') + ' ' + i18n.gettext('乙方联系人头衔'),
      type: 'input',
      prop: 'partyaTitleText',
      checkVisible: data => data.partyaTitleType === 4,
      props: {
        placeholder: i18n.gettext('请输入'),
      },
      rules: ['required', ['maxLength', i18n.gettext('乙方联系人头衔'), 90]],
    },
    partyaPhone: {
      label: i18n.gettext('乙方联系方式（仅支持手机）'),
      type: 'phone',
      prop: 'partyaPhone',
      span: 13,
      props: {
        preText: PHONE_PERFIX[country],
        placeholder: i18n.gettext('请输入'),
      },
      rules: ['required', 'telePhone'],
    },
    platformType: {
      label: i18n.gettext('平台配送'),
      type: 'rich-radio-group',
      prop: 'platformType',
      props: {
        options: SIGN_DELIVERY_TYPE_LIST,
      },
      rules: ['required'],
    },
    platformRate: {
      label: i18n.gettext('平台配送佣金比例'),
      type: 'input',
      prop: 'platformRate',
      span: 13,
      checkVisible: data => data.platformType === 1,
      props: {
        placeholder: i18n.gettext('请输入'),
        appendText: '%',
      },
      rules: [
        'required',
        ['decimal', i18n.gettext('平台配送佣金比例'), 2],
        ['min', i18n.gettext('平台配送佣金比例'), 0],
      ],
    },
    deliveryMinRate: {
      label: i18n.gettext('平台配送最低服务费'),
      type: 'input',
      prop: 'deliveryMinRate',
      span: 13,
      checkVisible: data => data.platformType === 1,
      props: {
        placeholder: i18n.gettext('请输入'),
        readonly: true,
        disabled: true,
      },
      rules: [
        'required',
        ['decimal', i18n.gettext('平台配送最低服务费'), 2],
        ['min', i18n.gettext('平台配送最低服务费'), 0],
      ],
    },
    oneselfType: {
      label: i18n.gettext('自配送'),
      type: 'rich-radio-group',
      prop: 'oneselfType',
      span: 13,
      props: {
        options: SIGN_DELIVERY_TYPE_LIST,
      },
      rules: ['required'],
    },
    oneselfRate: {
      label: i18n.gettext('自配送佣金比例'),
      type: 'input',
      prop: 'oneselfRate',
      span: 13,
      checkVisible: data => data.oneselfType === 1,
      props: {
        appendText: '%',
        placeholder: i18n.gettext('请输入'),
      },
      rules: [
        ['required', i18n.gettext('自配送佣金比例')],
        ['decimal', i18n.gettext('平台配送最低服务费'), 2],
      ],
    },
    contractorType: {
      label: i18n.gettext('商户主体类型'),
      type: 'select',
      span: 13,
      prop: 'contractorType',
      props: {
        options: new Rule(function () {
          const lib = {
            MX: SIGN_CONTRACTOR_TYPE_LIST,
            BR: SIGN_CONTRACTOR_TYPE_LIST_BR,
            CL: SIGN_CONTRACTOR_TYPE_LIST_CL,
            PE: SIGN_CONTRACTOR_TYPE_LIST_PE,
          }
          return lib[country] || lib.MX
        }),
        placeholder: i18n.gettext('请选择'),
      },
      rules: ['required'],
    },
    contractPic: {
      label: i18n.gettext('合同照片'),
      type: 'custom-upload',
      prop: 'contractPic',
      // hide: new Rule(() => {
      //   return +_this.formModel.signType === 3
      // }),
      props: {
        max: 5,
        tip: sprintf(i18n.gettext('上传最大数量为%d张，图片上限为5MB'), 5),
        path: 'common.uploadPrivatePic',
      },
      formatter(file) {
        const key = file.response.data.key
        return {
          key,
        }
      },
      rules: new Rule(() => {
        const signType = checkFields ? signTypeForCheckField : _this.formModel.signType
        return +signType === 1 ? [['required', i18n.gettext('合同照片')]] : []
      }),
    },
    commissionSubsidyRatio: {
      label: i18n.gettext('佣金补贴比例'),
      type: 'rich-stepper',
      prop: 'commissionSubsidyRatio',
      span: 13,
      checkVisible: data => data.contractType === 2,
      props: {
        placeholder: i18n.gettext('请输入'),
        appendText: '%',
        min: 0,
        max: 99,
      },
      rules: ['required', ['min', i18n.gettext('佣金补贴比例'), 1]],
    },
    commissionSubsidyDays: {
      label: i18n.gettext('佣金补贴周期'),
      type: 'rich-stepper',
      prop: 'commissionSubsidyDays',
      span: 13,
      checkVisible: data => data.contractType === 2,
      props: {
        placeholder: i18n.gettext('请输入'),
        appendText: '%',
        min: 0,
        max: 365,
      },
      rules: ['required', ['min', i18n.gettext('佣金补贴周期'), 1]],
    },
    commissionAuditPics: {
      label: i18n.gettext('佣金审核证明'),
      type: 'custom-upload',
      prop: 'commissionAuditPics',
      props: {
        max: 2,
        tip: sprintf(i18n.gettext('上传最大数量为%d张，图片上限为5MB'), 2),
        path: 'common.uploadPrivatePic',
      },
      checkVisible: data => data.contractType === 2,
      formatter(file) {
        const key = file.response.data.key
        return {
          key,
        }
      },
      rules: [['required', i18n.gettext('佣金审核证明')]],
    },
    accountHolder: {
      label: i18n.gettext('持卡人姓名'),
      hide: new Rule(() => {
        return ['CO', 'BR', 'CL', 'PE'].indexOf(country) !== -1
      }),
      type: 'input',
      prop: 'accountHolder',
      props: {
        placeholder: i18n.gettext('请输入'),
      },
      rules: ['required', ['maxLength', i18n.gettext('持卡人姓名'), 90], 'specialChars'],
    },
    accountHolderId: {
      label: new Rule(() => {
        if (isCountryChile()) {
          return i18nVue.t('FoodB_CL_RUT_roUA' /** RUT */)
        }
        if (['DO'].indexOf(country) !== -1) {
          const personal = i18n.gettext('个人') + 'Tax id'
          const company = i18n.gettext('公司') + 'RNC'
          return get(this, 'signForm.accountInfo.accountType') === 1 ? company : personal
        }
        return i18n.gettext('持卡人姓名')
      }),
      hide: new Rule(() => {
        if (country === 'DO' || country === 'CL') {
          return false
        }
        return (
          ['CR', 'CO', 'BR', 'PE', 'MX'].indexOf(country) !== -1 ||
          get(this, 'signForm.accountInfo.accountType') == null
        )
      }),
      type: 'input',
      prop: 'accountHolderId',
      props: {
        placeholder: i18n.gettext('请输入'),
      },
      rules: new Rule(() => {
        if (isCountryChile()) {
          return ['required', ['RUTRule', i18nVue.t('FoodB_CL_RUT_roUA' /** RUT */)]]
        }
        return get(this, 'signForm.accountInfo.accountType') === 1
          ? [...['required', ['maxLength', i18n.gettext('公司') + 'RNC', 9], 'specialChars']]
          : [...['required', ['maxLength', i18n.gettext('个人') + 'Tax id', 11], 'specialChars']]
      }),
    },
    accountCompany: {
      label: i18n.gettext('开户公司名'),
      hide: new Rule(() => {
        return ['CO', 'BR', 'CL', 'PE', 'BR'].indexOf(country) === -1
      }),
      checkVisible: data => data.accountType === 1,
      type: 'input',
      prop: 'accountFirstName',
      props: {
        placeholder: i18n.gettext('请输入'),
      },
      rules: new Rule(() => {
        if (isCountryChile()) {
          return ['required']
        }
        return ['required', ['maxLength', i18n.gettext('开户公司名'), 90]]
      }),
    },
    accountFirstName: {
      label: getCountryFullNameConfig(country).firstName, // 持卡人姓 或 持卡人名,
      hide: new Rule(() => {
        return ['CO', 'BR', 'CL', 'PE', 'BR'].indexOf(country) === -1
      }),
      type: 'input',
      checkVisible: data => {
        return data.accountType === 2
      },
      prop: 'accountFirstName',
      props: {
        placeholder: i18n.gettext('请输入'),
      },
      rules: [
        'required',
        ['maxLength', i18n.gettext('持卡人姓'), isCountryChile() ? 100 : 90],
        'specialChars',
      ],
    },
    accountLastName: {
      label: getCountryFullNameConfig(country).lastName, // 持卡人姓 或 持卡人名,
      hide: new Rule(() => {
        return ['CO', 'BR', 'CL', 'PE', 'BR'].indexOf(country) === -1
      }),
      type: 'input',
      prop: 'accountLastName',
      props: {
        placeholder: i18n.gettext('请输入'),
      },
      checkVisible: data => {
        return ['CO', 'BR', 'CL', 'PE'].indexOf(country) !== -1 && data.accountType === 2
      },
      rules: [
        'required',
        ['maxLength', i18n.gettext('持卡人名'), isCountryChile() ? 100 : 90],
        'specialChars',
      ],
    },
    accountHolderIdBR: {
      label:
        get(this, 'signForm.accountInfo.accountType') === 1
          ? i18n.gettext('开户公司CNPJ')
          : i18n.gettext('帐户持有人CPF'),
      type: 'CPFInput',
      hide: country !== 'BR',
      prop: 'accountHolderId',
      props: {
        placeholder: i18n.gettext('请输入'),
        numType: get(this, 'signForm.accountInfo.accountType') === 1 ? 'CNPJ' : '',
      },
      rules: [
        'required',
        get(this, 'signForm.accountInfo.accountType') === 1 ? 'cnpjRules' : 'cpfRules',
        'isBankIOReg',
      ],
    },
    accountAddr: {
      label: i18n.gettext('持卡人地址'),
      type: 'input',
      hide: new Rule(() => {
        return ['PE', 'BR'].indexOf(country) !== -1
      }),
      prop: 'accountAddr',
      props: {
        placeholder: i18n.gettext('请输入'),
      },
      rules: ['required', ['maxLength', i18n.gettext('持卡人地址'), 150]],
    },
    accountCardno: {
      label: i18n.gettext('银行卡号'),
      type: 'input',
      prop: 'accountCardno',
      hide: country === 'BR',
      props: {
        placeholder:
          country === 'PE'
            ? i18nVue.t('FoodOpB_Translation_Enter_CCI_YyDK' /** 请输入CCI账号 */)
            : i18n.gettext('请输入'),
      },
      rules: ['required', ['CRBankCardRule', i18n.gettext('银行卡号')]],
    },
    confirmAccountCardno: {
      label: i18n.gettext('确认银行卡号'),
      type: 'input',
      hide: country === 'BR',
      prop: 'confirmAccountCardno',
      span: 13,
      checkVisible: data => data.accountCardno !== data.backupAccountCardno,
      props: {
        placeholder: i18n.gettext('请输入'),
      },
      rules: ['required', 'CRBankCardRule'],
      detailView: {
        checkVisible() {
          return false
        },
      },
    },
    taxId: {
      label: i18n.gettext('税号'),
      type: 'input',
      prop: 'taxId',
      props: {
        placeholder: i18n.gettext('请输入'),
      },
      rules: new Rule(() => {
        const Dic = {
          CO: ['required', ['requireLength', i18n.gettext('税号'), 11]],
          COM: ['required', ['requireLength', i18n.gettext('税号'), 12]],
          DO: ['required', ['maxLength', i18n.gettext('税号'), 11]],
          CL: ['required', ['requireMultyLength', i18n.gettext('税号'), 8, 9]],
          PE: ['required', 'number', ['requireLength', i18n.gettext('税号'), 11]],
          MX: ['required', 'taxIdRules'],
          BR: [], // 巴西税号与加特兰保持一致非必填
        }
        return Dic[country] || Dic.COM
      }),
    },
    taxIdcif: {
      label: i18nVue.t('FoodB_collection_idCIF_qqcc' /** taxIdcif */),
      type: 'input',
      hide: country !== 'MX',
      prop: 'taxIdcif',
      placeholder: i18nVue.t('FoodB_collection_Enter_idCIF_NeUD' /** 请输入idCIF */),
      rules: ['required', 'taxIdcifRules'],
    },
    taxInfoSearch: {
      label: i18nVue.t('FoodB_collection_Taxpayer_Information_fQid' /** '纳税信息查询' **/),
      prop: 'taxInfoSearch',
      hide: country !== 'MX',
      props: {
        placeholder: i18n.gettext('请输入'),
        btnText: i18nVue.t('FoodB_collection_Taxpayer_Information_fQid'),
        baseLink: `https://siat.sat.gob.mx/app/qr/faces/pages/mobile/validadorqr.jsf?D1=10&D2=1&D3=`,
        linkKeys: ['taxIdcif', 'taxId'],
        dpListKey: [
          {
            key: 'taxIdcif',
            reg: /^\d{11}$/,
          },
          {
            key: 'taxId',
            reg: /^([A-Z]|\d){12,13}$/,
          },
        ],
      },
      type: 'actionWithUrl',
    },
    taxPics: {
      label: i18n.gettext('附件照片'),
      type: 'custom-upload',
      prop: 'taxPics',
      props: {
        max: 5,
        tip: sprintf(i18n.gettext('上传最大数量为%d张，图片上限为%dM'), 5, 5),
      },
      rules: new Rule(() => {
        if (country === 'BR') {
          // 巴西税号与加特兰保持一致非必填
          return []
        }
        return ['required']
      }),
      detailView: {
        type: 'image',
      },
    },
    startupCost: {
      label: new Rule(() => {
        return isCountryChile()
          ? i18nVue.t('FoodB_CL_Amount_CLP_Tmnv' /** 金额（CLP） */)
          : i18n.gettext('金额')
      }),
      type: 'select',
      prop: 'startupCost',
      props: {
        placeholder: i18n.gettext('请选择'),
        options: new Rule(() => {
          if (country === 'CO') {
            return STARTUP_MONEY_SELECT_LIST_CONFIG_CO
          }
          if (country === 'CL') {
            return STARTUP_MONEY_SELECT_LIST_CONFIG_CL
          }
          if (country === 'PE') {
            return STARTUP_MONEY_SELECT_LIST_CONFIG_PE
          }
          if (country === 'MX') {
            return STARTUP_MONEY_SELECT_LIST_CONFIG_MX
          }
          if (country === 'BR') {
            return STARTUP_MONEY_SELECT_LIST_CONFIG_BR
          }
          return STARTUP_MONEY_SELECT_LIST_CONFIG_CO
        }),
      },
      rules: ['required'],
    },
    startupExecWeek: {
      label: i18n.gettext('开始扣费时间'),
      type: 'input',
      prop: 'startupExecWeek',
      props: {
        readonly: true,
      },
    },
    startupCostProportion: {
      label: i18n.gettext('扣费比例'),
      type: 'input',
      props: {
        readonly: true,
      },
      prop: 'startupCostProportion',
    },
    startupCostLimit: {
      label: new Rule(() => {
        return isCountryChile()
          ? i18nVue.t('FoodB_CL_Maximum_amount_oflZ' /** 单次最大扣费金额（CLP） */)
          : i18n.gettext('单次最大扣费金额')
      }),
      type: 'input',
      props: {
        // readonly: true
      },
      prop: 'startupCostLimit',
      rules: new Rule(() => {
        if (isCountryChile()) {
          return ['required']
        }
        return ['required', ['cost', i18n.gettext('单次最大扣费金额(MX$)'), 5000]]
      }),
    },
    deviceFlagbinNeedPad: {
      label: i18n.gettext('Pad'),
      type: 'select',
      prop: 'deviceFlagbinNeedPad',
      props: {
        placeholder: i18n.gettext('请选择'),
        options: EQUIPMENT_INFO_PAD_SELECT_LIST,
      },
      rules: ['required'],
    },
    authorizedPics: {
      label: i18n.gettext('被授权人证件照片'),
      type: 'custom-upload',
      prop: 'authorizedPics',
      props: {
        max: 2,
        tip: sprintf(i18n.gettext('上传最大数量为%d张，图片上限为5MB'), 2),
        path: 'common.uploadPrivatePic',
      },
      formatter(file) {
        const key = file.response.data.key
        return {
          key,
        }
      },
    },
    pics: {
      label: i18n.gettext('授权书照片'),
      type: 'custom-upload',
      prop: 'pics',
      props: {
        max: 2,
        tip: sprintf(i18n.gettext('上传最大数量为%d张，图片上限为5MB'), 2),
        path: 'common.uploadPrivatePic',
      },
      formatter(file) {
        const key = file.response.data.key
        return {
          key,
        }
      },
    },
    emailInfo: {
      pics: {
        label: i18n.gettext('附件照片'),
        type: 'custom-upload',
        prop: 'pics',
        props: {
          max: 5,
        },
        tip: sprintf(i18n.gettext('上传最大数量为%d张，图片上限为5MB'), 5),
      },
    },
    bankInfo: {
      pics: {
        label: i18n.gettext('附件照片'),
        type: 'custom-upload',
        prop: 'pics',
        props: {
          max: 5,
        },
        rules: new Rule(() => {
          if (
            country === 'CO' ||
            country === 'CL' ||
            country === 'PE' ||
            country === 'MX' ||
            country === 'BR' ||
            country === 'CR'
          ) {
            /** 哥伦比亚银行流水是必填 */
            return [['required', i18n.gettext('银行')]]
          }
          return []
        }),
        tip: sprintf(i18n.gettext('上传最大数量为%d张，图片上限为5MB'), 5),
      },
    },
    accountBank: {
      label: country === 'PE' ? i18n.gettext('开户行') : i18n.gettext('银行'),
      type: 'bankSelect',
      prop: 'accountBank',
      props: {
        placeholder: i18n.gettext('请选择'),
        defaultValue: i18nVue.t('FoodOpB_information_The_selected_LyoI' /** 所选银行不支持结算 */),
      },
      hide: new Rule(() => {
        return ['CO', 'DO', 'CL', 'PE', 'BR'].indexOf(country) === -1
      }),
      rules: [['required', i18n.gettext('银行')]],
      // fetch: async function () {
      //   let country = getBDCountry()
      //   let locale = getBDLocale()
      //   // withBankList如果为1，表示bankmap返回的是有序的数组
      //   const types = {
      //     CO: 'bankMapFinance',
      //     CL: 'bankMap',
      //     DO: 'bankMap',
      //     PE: 'bankMap',
      //   }
      //   let type = types[country]
      //   let bankList = await fetchBankList({
      //     type,
      //     country,
      //     locale,
      //     withBankList: 1
      //   })
      //   let data = bankList.data
      //   const bankListResult = data.map((item) => {
      //     return {
      //       text: item.value,
      //       value: item.key
      //     }
      //   })
      //   return {
      //     options: bankListResult
      //   }
      // }
    },
    othersInfo: {
      pics: {
        label: i18n.gettext('附件照片'),
        type: 'custom-upload',
        prop: 'pics',
        props: {
          max: 5,
        },
        tip: sprintf(i18n.gettext('上传最大数量为%d张，图片上限为5MB'), 5),
      },
    },
    extraFiles: {
      label: i18n.gettext('附件信息'),
      type: 'static',
      prop: 'extraFiles',
    },
    itemPics: {
      label: i18n.gettext('菜单照片'),
      type: 'custom-upload',
      prop: 'itemPics',
      props: {
        max: 20,
      },
      tip: sprintf(i18n.gettext('上传最大数量为%d张，图片上限为5MB'), 20),
      rules: ['required'],
    },
    desc: {
      label: i18n.gettext('附件说明'),
      type: 'textarea',
      prop: 'desc',
      // checkVisible: data => data.pics && data.pics.length,
      props: {
        placeholder: i18n.gettext('请输入'),
        maxlength: 400,
      },
      rules: [['maxLength', i18n.gettext('附件说明'), 400]],
    },
    taxPayerIdType: {
      label: i18nVue.t('FoodB_Show_Taxpayer_Document_TFeg'),
      type: 'select',
      prop: 'taxPayerIdType',
      props: {
        options: new Rule(() => {
          if (get(this, 'signForm.contractInfo.contractorType') === 3) {
            return ID_TYPE_PERSONAL
          }
          return ID_TYPE_COMPANY
        }),
        placeholder: i18n.gettext('请选择'),
      },
      rules: ['required'],
      hide: new Rule(() => {
        return ['CR'].indexOf(country) === -1
      }),
      detailView: {
        format(data, prop) {
          const val = data[prop]
          const ID_LIST =
            get(this, 'signForm.contractInfo.contractorType') === 3
              ? ID_TYPE_PERSONAL
              : ID_TYPE_COMPANY
          const fd = ID_LIST.find(d => {
            return d.value === +val
          })
          return fd && fd.text
        },
      },
    },
    localTaxPayerIdType: {
      label: i18nVue.t('FoodB_Show_Taxpayer_Document_eadz'),
      type: 'select',
      prop: 'localTaxPayerIdType',
      props: {
        options: new Rule(() => {
          if (get(this, 'signForm.contractInfo.contractorType') === 3) {
            return ID_TYPE_PERSONAL
          }
          return ID_TYPE_COMPANY
        }),
        placeholder: i18n.gettext('请选择'),
      },
      hide: new Rule(() => {
        return ['CR'].indexOf(country) === -1
      }),
      detailView: {
        format(data, prop) {
          const val = data[prop]
          const ID_LIST =
            get(this, 'signForm.contractInfo.contractorType') === 3
              ? ID_TYPE_PERSONAL
              : ID_TYPE_COMPANY
          const fd = ID_LIST.find(d => {
            return d.value === +val
          })
          return fd && fd.text
        },
      },
    },
    taxVatPayment: {
      label: i18nVue.t('FoodB_field_Is_you_uNye' /** 是否需平台申报全国的税 */),
      type: 'select',
      prop: 'taxVatPayment',
      span: 13,
      props: {
        placeholder: i18n.gettext('请选择'),
        options: TAX_VAT_PAYMENT_LIST,
      },
      rules: ['required'],
      hide: new Rule(() => {
        return ['CO', 'CL'].indexOf(country) === -1
      }),
      detailView: {
        format(data, prop) {
          const val = data[prop]
          const fd = TAX_VAT_PAYMENT_LIST.find(d => {
            return d.value === val
          })
          return fd && fd.text
        },
      },
    },
    localTaxVatPayment: {
      label: i18nVue.t('FoodB_field_Do_you_mhOz' /** 是否需平台申报当地的税 */),
      type: 'select',
      prop: 'localTaxVatPayment',
      span: 13,
      props: {
        placeholder: i18n.gettext('请选择'),
        options: LOCALE_TAX_VAT_PAYMENT_LIST,
      },
      hide: new Rule(() => {
        return ['CO', 'CL'].indexOf(country) === -1
      }),
      detailView: {
        format(data, prop) {
          const val = data[prop]
          const fd = LOCALE_TAX_VAT_PAYMENT_LIST.find(d => {
            return d.value === val
          })
          return fd && fd.text
        },
      },
    },
    ka: {
      label: i18nVue.t('Gattaran_transformation__AByw'),
      type: 'select',
      prop: 'ka',
      props: {
        options: SIGN_PARTY_TYPE_LIST_V2,
        placeholder: i18n.gettext('请选择'),
        disabled: true,
      },
      rules: ['required'],
      detailView: {
        format(data, prop) {
          const val = data[prop]
          const fd = SIGN_PARTY_TYPE_LIST_V2.find(d => d.value === val)
          return fd ? fd.text : i18n.gettext('暂无')
        },
      },
    },
    sellerName: {
      label: i18n.gettext('销售姓名'),
      type: 'sugSelect',
      prop: 'sellerName',
      props: {
        type: 'sellerName',
        sugName: 'UserSugSelect', // sug 弹窗 组件名
        placeholder: i18n.gettext('姓名'),
      },
      rules: ['required'],
    },
    sellerPhone: {
      label: i18n.gettext('销售电话'),
      type: 'input',
      prop: 'sellerPhone',
      props: {
        disabled: true,
      },
    },
  }
}
